const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateQuickCapture = (data) => {
  const errors = {};

  if (!data.full_name || data.full_name.trim().length < 3)
    errors.full_name = "Nome deve ter pelo menos 3 caracteres.";

  const whatsappDigits = (data.whatsapp || "").replace(/\D/g, "");
  if (whatsappDigits.length < 10 || whatsappDigits.length > 11)
    errors.whatsapp = "WhatsApp deve ter 10 ou 11 dígitos (DDD + número).";

  if (!data.restaurant_name || data.restaurant_name.trim().length < 2)
    errors.restaurant_name = "Nome do restaurante deve ter pelo menos 2 caracteres.";

  return errors;
};

export const validateDetails = (data) => {
  const errors = {};

  if (data.email && !emailRegex.test(data.email))
    errors.email = "E-mail inválido.";

  if (data.cpf_cnpj) {
    const digits = data.cpf_cnpj.replace(/\D/g, "");
    if (![11, 14].includes(digits.length))
      errors.cpf_cnpj = "CPF (11 dígitos) ou CNPJ (14 dígitos).";
  }

  if (data.address_cep) {
    const digits = data.address_cep.replace(/\D/g, "");
    if (digits.length !== 8)
      errors.address_cep = "CEP deve ter 8 dígitos.";
  }

  // Validate restaurant names if any restaurants exist
  if (data.restaurants && data.restaurants.length > 0) {
    const restaurantErrors = [];
    let hasError = false;
    data.restaurants.forEach((r, i) => {
      const rErr = {};
      if (!r.name || r.name.trim().length < 2) {
        rErr.name = "Nome do restaurante é obrigatório.";
        hasError = true;
      }
      restaurantErrors.push(rErr);
    });
    if (hasError) errors.restaurantErrors = restaurantErrors;
  }

  return errors;
};
